import { Link } from "react-router-dom";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { OFFICE_ADDRESS, OFFICE_MAP_URL } from "../config";

const quickLinks = [
  { key: "nav.home", to: "/" },
  { key: "nav.services", to: "/services" },
  { key: "nav.packages", to: "/packages" },
  { key: "nav.contact", to: "/contact" },
];

export default function Footer() {
  const { t } = useTranslation();

  const contactItems = [
    {
      icon: Phone,
      content: (
        <a href="tel:+918866077880" className="hover:text-brand-300 transition-colors">
          +91 88660 77880 / +91 94265 87801
        </a>
      ),
    },
    {
      icon: Mail,
      content: (
        <a href="mailto:support@shreemateltourism.in" className="hover:text-brand-300 transition-colors">
          support@shreemateltourism.in
        </a>
      ),
    },
    {
      icon: MapPin,
      content: (
        <a
          href={OFFICE_MAP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-brand-300 transition-colors"
        >
          {OFFICE_ADDRESS}
        </a>
      ),
    },
    { icon: Clock, content: t("footer.workingHours") },
  ];

  return (
    <footer className="bg-navy-950 text-white border-t-2 border-brand-600/40">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img
              src={`${process.env.PUBLIC_URL}/logo512.png`}
              alt="Shree Matel Tourism logo"
              className="w-12 h-12 rounded-full bg-white object-contain ring-2 ring-brand-500/60"
            />
            <div className="font-serif text-xl font-bold">
              {t("nav.brandName")} <span className="text-brand-400">{t("nav.brandNameHighlight")}</span>
            </div>
          </div>
          <p className="text-navy-300 text-sm leading-relaxed max-w-xs">
            {t("footer.tagline")}
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-serif font-bold text-lg mb-5 text-brand-400">{t("footer.quickLinks")}</h3>
          <div className="flex flex-col space-y-2.5">
            {quickLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-navy-300 hover:text-brand-300 transition-colors text-sm flex items-center gap-2 w-fit"
              >
                <span className="text-brand-500">→</span> {t(link.key)}
              </Link>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-serif font-bold text-lg mb-5 text-brand-400">{t("footer.contactUs")}</h3>
          <div className="space-y-3.5 text-navy-300 text-sm">
            {contactItems.map(({ icon: Icon, content }, i) => (
              <p key={i} className="flex items-start gap-3">
                <Icon size={16} className="text-brand-500 mt-0.5 shrink-0" />
                <span>{content}</span>
              </p>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-5 text-center text-navy-400 text-sm">
        {t("footer.copyright", { year: new Date().getFullYear() })}
      </div>
    </footer>
  );
}
